import { useCallback } from 'react';
import { useScrollContext, useSessionContext } from "../../../../../shared/model";
export var useReplyMessage = function useReplyMessage(replyMessage) {
  var _useSessionContext = useSessionContext(),
    refs = _useSessionContext.refs;
  var _useScrollContext = useScrollContext(),
    scrollRef = _useScrollContext.scrollRef;
  return useCallback(function () {
    if (replyMessage) {
      var ref = refs[replyMessage.message.messageId];
      if (ref.current && scrollRef.current) {
        scrollRef.current.scrollTo({
          top: ref.current.offsetTop - scrollRef.current.offsetHeight + ref.current.offsetHeight + 16,
          behavior: 'smooth'
        });
      }
    }
  }, [replyMessage, refs]);
};